export const SUPER_ADMIN = 'super-admin'
export const PAAS_ADMIN = 'PaaS'
export const PROVIDER_ADMIN = 'provider'
export const COMPANY_ADMIN = 'company'
